export function countryCityLogic() {
  const countrySelect = document.getElementById("date13-country");
  const citySelect = document.getElementById("date13-city");
  if (!countrySelect || !citySelect) {
    return;
  }

  const placeholder = citySelect.options[0];
  const cityOptions = Array.from(citySelect.options).filter((option) => option.value);

  countrySelect.addEventListener("change", () => {
    const selectedCountry = countrySelect.value;

    citySelect.replaceChildren(
      placeholder,
      ...cityOptions.filter((option) => option.dataset.country === selectedCountry),
    );
    citySelect.value = "";
  });
}
